import { motion } from 'framer-motion'
import { FaSave } from 'react-icons/fa'

interface PageHeaderProps {
  title: string
  onSave?: () => void
  isSaving?: boolean
  showSaveButton?: boolean
}

export default function PageHeader({
  title,
  onSave,
  isSaving = false,
  showSaveButton = true,
}: PageHeaderProps) {
  return (
    <div className="mb-8 border-b border-gray-200">
      <div className="flex items-center justify-between py-5">
        <div className="min-w-0 flex-1 px-4 sm:px-6">
          <h1 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl">
            {title}
          </h1>
        </div>
        {showSaveButton && onSave && (
          <div className="flex-shrink-0 px-4 sm:px-6">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={onSave}
              disabled={isSaving}
              className="inline-flex items-center rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50"
            >
              <FaSave className="mr-2 h-4 w-4" />
              {isSaving ? 'Salvando...' : 'Salvar Alterações'}
            </motion.button>
          </div>
        )}
      </div>
    </div>
  )
} 